<div [class.design-shell]="shellOnly"
     [class.plain-shell]="!shellOnly"
     [class.samekonomi-theme]="isSamekonomiTheme"
     [class.navigation-collapsed]="shellOnly && isNavigationCollapsed">
  <ng-container *ngIf="shellOnly">
    <div class="mobile-backdrop" [class.is-visible]="isMobileNavigationOpen" (click)="closeMobileNavigation()"></div>

    <aside class="side-navigation" [class.is-open]="isMobileNavigationOpen" aria-label="Huvudmeny">
      <div class="brand-row">
        <a class="brand"
           [routerLink]="isSamekonomiWithoutOrganization || isNavigationCollapsed ? null : homeLink"
           (click)="!isSamekonomiWithoutOrganization && openCollapsedNavigation()"
           [attr.aria-label]="isNavigationCollapsed ? 'Öppna menyn' : 'Till startsidan'">
          <span class="brand-mark"><img [src]="logo" alt="" /></span>
          <span class="brand-name" *ngIf="!isSamekonomiTheme">{{productName}}</span>
        </a>
        <button type="button"
                class="navigation-toggle"
                (click)="togglePrimaryNavigation()"
                [disabled]="isSamekonomiWithoutOrganization"
                aria-label="Stäng menyn"
                title="Stäng menyn">
          <mat-icon>{{ isNavigationCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
        <button mat-icon-button type="button" class="mobile-close" (click)="closeMobileNavigation()" aria-label="Stäng menyn">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <nav class="navigation-groups" *ngIf="!isSamekonomiWithoutOrganization">
        <div class="navigation-group" *ngFor="let group of navigationGroups">
          <span class="navigation-label">{{group.label}}</span>
          <a class="navigation-item"
             *ngFor="let item of group.items"
             [routerLink]="item.link"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: item.link === homeLink }"
             [attr.title]="isNavigationCollapsed ? item.label : null"
             (click)="closeMobileNavigation()">
            <mat-icon>{{item.icon}}</mat-icon><span>{{item.label}}</span>
            <span *ngIf="isAdmin && item.link === '/admin/task-center' && pendingTaskCenterCount() > 0"
                  class="navigation-task-badge">{{pendingTaskCenterCount()}}</span>
          </a>
          <button class="navigation-item navigation-action"
                  type="button"
                  *ngIf="group.label === 'Hantera' && canManageEmployees"
                  [attr.title]="isNavigationCollapsed ? 'Hantera medarbetare' : null"
                  (click)="openEmployeeManagement()">
            <mat-icon>group_add</mat-icon><span>Hantera medarbetare</span>
          </button>
          <button class="navigation-item navigation-action"
                  type="button"
                  *ngIf="group.label === 'Hantera' && canEditCompany"
                  [attr.title]="isNavigationCollapsed ? 'Redigera företagsuppgifter' : null"
                  (click)="openCompanyEditor()">
            <mat-icon>business</mat-icon><span>Redigera företagsuppgifter</span>
          </button>
        </div>
      </nav>

      <div class="navigation-footer">
        <a class="navigation-item help-link" *ngIf="!isSamekonomiWithoutOrganization" routerLink="/contact" (click)="closeMobileNavigation()">
          <mat-icon>help_outline</mat-icon><span>Hjälp och kontakt</span>
        </a>
        <a class="user-card" *ngIf="!isSamekonomiWithoutOrganization" routerLink="/settings" (click)="closeMobileNavigation()">
          <span class="avatar">{{initial}}</span>
          <span class="user-copy"><strong>Inställningar</strong><small>{{fullName}}</small></span>
          <mat-icon>expand_more</mat-icon>
        </a>
      </div>
    </aside>
  </ng-container>

  <section [class.main-area]="shellOnly" [class.plain-content]="!shellOnly">
    <ng-container *ngIf="shellOnly">
      <header class="top-bar">
        <button mat-icon-button type="button" class="mobile-menu-button" (click)="togglePrimaryNavigation()" [disabled]="isSamekonomiWithoutOrganization" [attr.aria-label]="isNavigationCollapsed ? 'Öppna menyn' : 'Stäng menyn'">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="top-spacer"></span>
        <nav class="utility-navigation" aria-label="Snabblänkar">
          <a mat-icon-button *ngIf="!isSamekonomiWithoutOrganization" [routerLink]="homeLink" aria-label="Start"><mat-icon>grid_view</mat-icon></a>
          <a mat-icon-button
             *ngFor="let item of isSamekonomiWithoutOrganization ? [] : topNavigation"
             [routerLink]="item.link"
             [attr.aria-label]="item.label"
             [attr.title]="item.label">
            <mat-icon>{{item.icon}}</mat-icon>
          </a>
          <button mat-icon-button
                  type="button"
                  *ngIf="canManageEmployees && !isSamekonomiWithoutOrganization"
                  (click)="openEmployeeManagement()"
                  aria-label="Hantera medarbetare"
                  title="Hantera medarbetare">
            <mat-icon>group_add</mat-icon>
          </button>
          <button mat-icon-button
                  type="button"
                  *ngIf="!isSamekonomiWithoutOrganization && secondaryNavigation.length > 0"
                  [matMenuTriggerFor]="secondaryMenu"
                  aria-label="Fler alternativ">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #secondaryMenu="matMenu" xPosition="before" class="modern-more-menu">
            <a mat-menu-item *ngFor="let item of secondaryNavigation" [routerLink]="item.link">
              <mat-icon color="accent">{{item.icon}}</mat-icon>
              <span>{{item.label}}</span>
            </a>
          </mat-menu>
          <button mat-icon-button
                  type="button"
                  class="account-menu-button"
                  [disableRipple]="true"
                  [matMenuTriggerFor]="accountMenu"
                  aria-label="Konto">
            <span class="account-menu-content">
              <span class="top-avatar">{{initial}}</span>
              <mat-icon class="account-chevron">expand_more</mat-icon>
            </span>
          </button>
          <mat-menu #accountMenu="matMenu" xPosition="before">
            <a mat-menu-item *ngIf="!isSamekonomiWithoutOrganization" routerLink="/settings">
              <mat-icon>settings</mat-icon>
              <span>Inställningar</span>
            </a>
            <button mat-menu-item type="button" (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>Logga ut</span>
            </button>
          </mat-menu>
        </nav>
      </header>

      <div *ngIf="impersonationState as state" class="impersonation-banner" role="status" aria-live="polite">
        <div class="impersonation-message">
          <mat-icon aria-hidden="true">manage_accounts</mat-icon>
          <span>
            Du är inloggad som <strong>{{state.targetDisplayName}}</strong>
            <span *ngIf="state.targetEmail"> ({{state.targetEmail}})</span>
            på uppdrag av {{state.actorDisplayName}}.
          </span>
        </div>
        <button mat-flat-button
                type="button"
                [disabled]="isStoppingImpersonation"
                (click)="stopImpersonation()">
          <mat-icon>undo</mat-icon>
          Återgå till admin
        </button>
      </div>
    </ng-container>

    <div *ngIf="!shouldHideContentUntilOrganizationResolution"
         [class.shell-content]="shellOnly"
         [class.dashboard-shell-content]="shellOnly && isDashboardRoute">
      <ng-content></ng-content>
    </div>
  </section>
</div>
